module.exports = __webpack_public_path__ + "img/bondora@2x.e05466a.png";